import { memo, FC } from 'react'
import { Select } from '@chakra-ui/react'

import { DynamicFieldProps } from '../..'

const BooleanFilterField: FC<DynamicFieldProps> = ({ name, register }) => {
  return (
    <Select {...register(name)}>
      <option value="">Sem valor</option>
      <option value="Sim">Sim</option>
      <option value="Não">Não</option>
    </Select>
  )
}

export default memo(BooleanFilterField)
